


// import React from "react";
// import { Box, Typography, Container, Stack, useMediaQuery, useTheme } from "@mui/material";

// const featuresLeft = [
//   {
//     icon: "/Images/deposit.png",
//     title: "Instant deposits",
//     subtitle: "Wide array of deposit methods to fund your account.",
//   },
//   {
//     icon: "/Images/second.png",
//     title: "Unmatched spreads",
//     subtitle: "Trade with tight and stable spreads, even during market moves.",
//   },
//   {
//     icon: "/Images/third.png",
//     title: "24/7 Live support",
//     subtitle: "Get help via phone, chat, or email — in 13 languages.",
//   },
// ];

// const featuresRight = [
//   {
//     icon: "/Images/fourth.png",
//     title: "Instant withdrawals",
//     subtitle: "Funds hit your account instantly. T&Cs apply.",
//   },
//   {
//     icon: "/Images/fifth.png",
//     title: "More speed, less slippage",
//     subtitle: "Get the most precise execution in the market.",
//   },
//   {
//     icon: "/Images/sixth.png",
//     title: "Best-in-class security",
//     subtitle: "Your funds are protected in segregated client accounts.",
//   },
// ];

// const FeatureItem = ({ icon, title, subtitle, direction }) => (
//   <Box
//     sx={{
//       textAlign: direction === "left" ? "right" : "left",
//       position: "relative",
//       display: "flex",
//       flexDirection: "column",
//       alignItems: direction === "left" ? "flex-end" : "flex-start",
//     }}
//   >
//     <Box
//       sx={{
//         position: "relative",
//         mb: 1,
//         display: "flex",
//         alignItems: "center",
//       }}
//     >
//       <Box
//         sx={{
//           position: "relative",
//           mb: 1,
//           display: "flex",

//           alignItems: "center",
//           justifyContent: direction === "left" ? "left" : "center", // Align left if direction is "left"
//           width: "100%", // Ensures full width so content can align left
//         }}
//       >
//         {direction === "left" && (
//           <>
//             <Box
//               component="img"
//               src="/Images/circleshadow.png"
//               alt="Arrow"
//               sx={{
//                 width: 30,
//                 height: 30,
//                 mr: 1,
//                 transform: "scaleX(-1)",
//               }}
//             />

//             <Box
//               sx={{
//                 height: "3px",
//                 borderTop: "2px dotted rgba(255,255,255,0.5)",
//                 mr: 1,
//                 width: { xs: "40px", md: "170px" },
//               }}
//             />
//           </>
//         )}

//         <Box
//           component="img"
//           src={icon}
//           alt={title}
//           sx={{
//             width: 172,
//             height: 52,
//             objectFit: "contain", // Ensures the image scales without distortion
//             imageRendering: "auto", // Use "crisp-edges" or "pixelated" for icons
//           }}
//         />

//       </Box>

//       <Box
//         sx={{
//           position: "relative",
//           mb: 1,
//           display: "flex",

//           alignItems: "center",
//           justifyContent: direction === "left" ? "left" : "center", // Align left if direction is "left"
//           width: "100%", // Ensures full width so content can align left
//         }}
//       >
//         {direction === "right" && (
//           <>
//             {/* Dotted Line */}
//             <Box
//               sx={{
//                 height: "3px",
//                 borderTop: "2px dotted rgba(255,255,255,0.5)",
//                 mr: 1,
//                 width: { xs: "40px", md: "170px" },
//               }}
//             />
//             {/* Arrow After Dotted */}
//             <Box
//               component="img"
//               src="/Images/circleshadow.png"
//               alt="Arrow"
//               sx={{ width: 30, height: 30, ml: 1 }}
//             />
//           </>
//         )}
//       </Box>
//     </Box>
//     {/* Text */}
//     <Typography fontSize="1rem" sx={{ mb: 0.5 }}>
//       {title}
//     </Typography>
//     <Typography
//       fontSize="0.9rem"
//       color="rgba(255,255,255,0.7)"
//       maxWidth={220}
//       fontWeight={200}
//     >
//       {subtitle}
//     </Typography>
//   </Box>
// );


// const Market = () => {
//   const theme = useTheme();
//   const isSmall = useMediaQuery(theme.breakpoints.down("md"));
//   return (
//     <Box
//       sx={{
//         width: "100%",
//         minHeight: "100vh",
//         position: "relative",
//         backgroundImage: "url(/Images/mtblue.png)",
//         backgroundSize: "cover",
//         backgroundPosition: "center",
//         backgroundRepeat: "no-repeat",
//         display: "flex",
//         flexDirection: "column",
//         alignItems: "center",
//         color: "#fff",
//         textAlign: "center",
//         pt: { xs: 6, md: 13 },
//         pb: { xs: 6, md: 0 }, // <= Important
//         px: 2,
//       }}
//     >

//       {/* Overlay */}
//       <Box
//         sx={{
//           position: "absolute",
//           inset: 0,
//           backgroundColor: "rgba(0, 0, 0, 0.4)",
//           zIndex: 1,
//         }}
//       />

//       {/* Heading */}
//       <Container
//         sx={{
//           position: "relative",
//           zIndex: 2,
//           maxWidth: "md",
//           mb: { xs: 6, md: 10 },
//         }}
//       >
//         <Typography variant="h2" sx={{ lineHeight: '70px' }}>
//           Thrive in the gold, oil, indices, and<br />
//           crypto markets
//         </Typography>
//         <Typography
//           sx={{
//             mt: 2,
//             color: "rgba(255, 255, 255, 0.7)",
//             fontSize: { xs: "1rem", md: "1.25rem" },
//             fontWeight: 500,
//           }}
//         >
//           Trading conditions can make or break a strategy, that’s why you need
//           the best.
//         </Typography>
//       </Container>

//       {/* Feature Layout */}
//       <Box
//         sx={{
//           position: "relative",
//           zIndex: 2,
//           display: "flex",
//           flexDirection: { xs: "column", md: "row" },
//           alignItems: "center",
//           justifyContent: "center",
//           gap: { xs: 6, md: 8 },
//         }}
//       >
//         {/* Left */}
//         <Stack spacing={4} sx={{ maxWidth: 300 }}>
//           {featuresLeft.map((item, index) => (
//             <FeatureItem key={index} {...item} direction="right" />
//           ))}
//         </Stack>

//         {/* Phone */}
//         <Box
//           component="img"
//           src="/Images/phone.png"
//           alt="Phone"
//           sx={{
//             width: { xs: "180px", md: "400px" },
//             mt: { xs: 4, md: 0 },
//           }}
//         />

//         {/* Right */}
//         <Stack spacing={4} sx={{ maxWidth: 300 }}>
//           {featuresRight.map((item, index) => (
//             <FeatureItem key={index} {...item} direction={isSmall ? "right" : "left"} />))}
//         </Stack>
//       </Box>
//       <Box
//         sx={{
//           position: "absolute",
//           bottom: 0,
//           left: 0,
//           width: "100%",
//           height: { xs: "100px", md: "150px" },
//           background: "linear-gradient(to top, rgba(3, 19, 40, 1), rgba(3, 19, 40, 0))",
//           zIndex: 2, // Same as content or just below it
//           pointerEvents: "none", 
//         }}
//       />
     
//     </Box>
//   );
// };

// export default Market;

import React from "react";
import { Box, Container, Typography, useMediaQuery, useTheme } from "@mui/material";

const BigComp = () => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const bgImageDesktop = "https://res.cloudinary.com/dk24unkwu/image/upload/v1753695254/BGG_s7tayf.png";
  const bgImageMobile = "https://res.cloudinary.com/dk24unkwu/image/upload/v1753695280/SMABG_ya0q1g.png";

  return (
    <Box
      sx={{
        backgroundImage: `url(${isSmallScreen ? bgImageMobile : bgImageDesktop})`,
        backgroundSize: "contain",
        backgroundPosition:"center",
        backgroundRepeat: "no-repeat",
        minHeight: { xs: "100vh", sm: "70vh", md: "100vh" },
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor:'#04142a',
        px: 2,
      }}
    >
      {/* <Container maxWidth="md" sx={{ textAlign: "center", color: "#fff" }}> */}
        {/* <Typography variant="h2" fontWeight="bold" mb={2}>
          Welcome to Our Platform
        </Typography>
        <Typography variant="h6">
          Trade smarter with intuitive tools and real-time analytics.
        </Typography> */}
      {/* </Container> */}
    </Box>
  );
};

export default BigComp;



